<div class="restricted-label flex gap-3 align-items-center">
    <label class="restricted-label-title"
           for="restricted-label-dropdown">Set preferred label for restricted data</label>
    <p-dropdown
        id="restricted-label-dropdown"
        [options]="options()"
        placeholder="Select Report Restricted Label"
        [ngModel]="selectedValue()"
        (ngModelChange)="selectedValue.set($event)"
        optionLabel="label"
        optionValue="value"
    ></p-dropdown>
</div>
